"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canJoinGroup = exports.fallbackMembership = exports.isAdmin = exports.pending = exports.joined = void 0;
var types_1 = require("@wix/ambassador-social-groups-v2-group-member/types");
var privacyLevel_1 = require("../Group/privacyLevel");
function joined(membership) {
    return membership.status === types_1.MembershipStatus.JOINED;
}
exports.joined = joined;
function pending(membership) {
    return membership.status === types_1.MembershipStatus.PENDING;
}
exports.pending = pending;
function isAdmin(membership) {
    var _a;
    if (membership === void 0) { membership = {}; }
    return joined(membership) && ((_a = membership.role) === null || _a === void 0 ? void 0 : _a.value) === types_1.Role.ADMIN;
}
exports.isAdmin = isAdmin;
function fallbackMembership(groupId, membership) {
    return (membership || {
        groupId: groupId,
        status: types_1.MembershipStatus.UNKNOWN_STATUS,
        role: { value: types_1.Role.UNKNOWN_ROLE },
    });
}
exports.fallbackMembership = fallbackMembership;
function canJoinGroup(groupV2, membership) {
    return !privacyLevel_1.isSecret(groupV2) || isAdmin(membership);
}
exports.canJoinGroup = canJoinGroup;
//# sourceMappingURL=index.js.map